import http from './http';
import type {
  Conversation,
  CreateConversationRequest,
  ChatMessage,
  SendMessageRequest,
} from '@/types/chat/chat.types';

export const chatApi = {
  /** Tạo hội thoại mới */
  createConversation: async (body: CreateConversationRequest): Promise<Conversation> => {
    const { data } = await http.post('/chat/conversations', body);
    return data.data ?? data;
  },

  /** Lấy danh sách hội thoại của user hiện tại */
  getConversations: async (): Promise<Conversation[]> => {
    const { data } = await http.get('/chat/conversations');
    return data.data ?? data;
  },

  /** Lấy lịch sử tin nhắn của hội thoại */
  getMessages: async (conversationId: string): Promise<ChatMessage[]> => {
    const { data } = await http.get(`/chat/messages/${conversationId}`);
    return data.data ?? data;
  },

  /** Gửi tin nhắn qua REST */
  sendMessage: async (body: SendMessageRequest): Promise<ChatMessage> => {
    const { data } = await http.post('/chat/message', body);
    return data.data ?? data;
  },

  /** Cập nhật thông tin hội thoại (title, isArchived) */
  updateConversation: async (conversationId: string, body: { title?: string; isArchived?: boolean }): Promise<Conversation> => {
    const { data } = await http.patch(`/chat/conversations/${conversationId}`, body);
    return data.data ?? data;
  },

  /** Đánh dấu hội thoại đã đọc */
  markAsRead: async (conversationId: string): Promise<void> => {
    const { data } = await http.post(`/chat/conversations/${conversationId}/read`);
    return data.data ?? data;
  },

  /** Xóa hội thoại */
  deleteConversation: async (conversationId: string): Promise<void> => {
    const { data } = await http.delete(`/chat/conversations/${conversationId}`);
    return data.data ?? data;
  },
};
